import React from 'react';
import { Layout } from 'antd';

function Footer() {
    return <Layout.Footer style={{ textAlign: 'center' }}>© {new Date().getFullYear()} BindFind</Layout.Footer>;
}

export default Footer;
